export default class GCGeneralConfigModel {
  considerFirstPurchaseDateForNewClient = false;

  constructor(considerFirstPurchaseDateForNewClient: boolean) {
    this.considerFirstPurchaseDateForNewClient = considerFirstPurchaseDateForNewClient;
  }
}
